import { Link } from "react-router-dom";
import {Bell} from 'lucide-react';
import { useAuth } from "@/hooks/useAuth";

export default function JobAlertSignup() {
  const { isAuthenticated } = useAuth();

  return (
    <section className="py-12 px-4 sm:px-6 max-w-7xl mx-auto">
      <div
        className="rounded-2xl border p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5"
        style={{ background: "#1a1f2e", borderColor: "rgba(249,115,22,0.25)" }}
      >
        <div className="flex items-start gap-4">
          <div
            className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0"
            style={{ background: "rgba(249,115,22,0.15)" }}
          >
            <Bell size={18} style={{ color: "#f97316" }} />
          </div>
          <div>
            <p className="text-xs uppercase tracking-wider mb-1" style={{ color: "#f97316", fontFamily: "JetBrains Mono, monospace" }}>
              Automated job radio
            </p>
            <h2 className="text-2xl font-black text-white mb-1" style={{ fontFamily: "Outfit, sans-serif" }}>
              Get emailed when new mining jobs drop
            </h2>
            <p className="text-sm text-gray-400 max-w-xl">
              Filter by FIFO, mineral, and experience. MineralJobs Board sends a matching alert the moment a listing is posted.
            </p>
          </div>
        </div>
        <Link
          to={isAuthenticated ? "/alerts" : "/auth?redirect=/alerts&mode=register"}
          className="inline-flex items-center justify-center px-5 py-3 rounded-xl font-semibold text-white whitespace-nowrap"
          style={{ background: "linear-gradient(135deg, #f97316, #ea580c)" }}
        >
          {isAuthenticated ? "Manage alerts" : "Set up alerts"}
        </Link>
      </div>
    </section>
  );
}
